import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './app/store';
import Login from './pages/Login/Login';
import { ErrorBoundary } from './components/ErrorBoundary';
import * as Sentry from "@sentry/react";
import { AppConfig } from './config/AppConfig';
import { AuthProvider } from './context/AuthContext';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
Sentry.init({
  dsn: "https://e92a16b447b08fc05d10e0e495c8c0e4@o409915.ingest.us.sentry.io/4508722817269760",
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      colorScheme: "system",
      isNameRequired: true,
      isEmailRequired: true,
    }),
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // Tracing
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/dash-v2-prod\.web\.app/, // Production
  /^https:\/\/dash-v2-qa\.web\.app/,   
  /^https:\/\/dash-v2-dev\.web\.app/,],
  profilesSampleRate: 1.0,
  environment: AppConfig.env || "dev",
});
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary fallback={<Login />}>
     
      <App />
      
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>,
);
